
import { mapGetters, mapActions } from 'vuex'
import LoleBackdrop from '~/components/common/lole-backdrop'
export default {
  name: 'SwitchLocation',
  components: {
    LoleBackdrop,
  },
  props: { isActive: Boolean },
  computed: {
    ...mapGetters({
      switchLocator: 'common/getSwitchLocator',
      vxCurrency: 'currency/getCurrency',
    }),
  },
  watch: {
    isActive(value) {
      if (value) {
        setTimeout(() => {
          if (this.$refs.enUsLink) {
            this.$refs.enUsLink.focus()
          }
        }, 500)
      }
    },
  },
  methods: {
    ...mapActions({
      vxSwitchCurrency: 'currency/switchCurrency',
      vxUpdateBuyerIdentity: 'cart/updateBuyerIdentity',
    }),
    pathWithoutQuery(newLang) {
      const path = this.$route.path
      if (path.includes('search') || path.includes('product'))
        return this.switchLocalePath(newLang)
      const newPath = this.switchLocalePath(newLang)
      const newPathArray = newPath.split('?')
      const cleanPath = newPathArray[0]
      return cleanPath
    },
    changeCookieI18n(lang) {
      try {
        this.$cookies.remove(`lole_i18n`)
        this.$cookies.set(`lole_i18n`, lang)
      } catch (e) {
        this.$sentryException(e, {
          source: 'Switch lang - changeCookieI18n()',
          level: 'warning',
          extra: 'failed to change lole_i18n cookie',
        })
      }
    },
    async switchCurrency(currency) {
      await this.vxUpdateBuyerIdentity(currency)
      await this.vxSwitchCurrency(currency)
      await this.$emit('close')
    },
  },
}
